import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PreTripChecklist from "@/pages/PreTripChecklist";

export const Route = createFileRoute("/rv-pre-trip-check-list")({
  head: () => pageHead({
    title: 'RV Pre-Trip Checklist',
    description: 'Use our RV pre-trip checklist before you hit the road — tires, lights, seals, tanks and safety checks from Rex & Sons RVs.',
    path: '/rv-pre-trip-check-list',
  }),
  component: PreTripChecklist,
});
